import { render, staticRenderFns } from "./SuggestedDoctor.vue?vue&type=template&id=49fa6578&scoped=true"
import script from "./SuggestedDoctor.vue?vue&type=script&lang=js"
export * from "./SuggestedDoctor.vue?vue&type=script&lang=js"
import style0 from "./SuggestedDoctor.vue?vue&type=style&index=0&id=49fa6578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fa6578",
  null
  
)

export default component.exports